// File type arrays for different categories
const IMAGE_FILE_TYPES = [
	"png",
	"jpeg",
	"jpg",
	"gif",
	"webp",
	"psd",
	"ai",
	"bmp",
	"tiff",
	"heic",
	"heif",
	"ico",
	"raw",
]

const DOCUMENT_FILE_TYPES = [
	"pdf",
	"doc",
	"docx",
	"ppt",
	"pptx",
	"md",
	"markdown",
	"text",
	"toml",
	"rtf",
]

const TABLE_FILE_TYPES = ["csv", "tsv", "xlsx", "ods", "xls"]

const ARCHIVE_FILE_TYPES = ["zip", "tar", "gz", "tgz", "rar", "7z", "iso"]

const AUDIO_FILE_TYPES = ["mp3", "wav", "ogg"]

const VIDEO_FILE_TYPES = [
	"mp4",
	"mov",
	"quicktime",
	"mkv",
	"avi",
	"wmv",
	"webm",
	"3gp",
	"m4v",
]

const CODE_FILE_TYPES = [
	"php",
	"cpp",
	"c",
	"lua",
	"js",
	"ts",
	"py",
	"tsx",
	"binary",
	"typescript",
	"javascript",
	"java",
	"html",
	"css",
	"yaml",
	"yml",
	"xml",
	"sh",
	"bash",
	"bat",
	"ps1",
	"go",
	"rb",
	"rs",
	"swift",
	"kt",
	"kotlin",
	"scala",
	"pl",
	"perl",
	"sql",
	"mdx",
	"log",
	"svg",
]

const EMAIL_FILE_TYPES = ["eml", "msg"]

const JSON_FILE_TYPES = ["json", "jsonl", "ndjson", "geojson"]

const TEXT_FILE_TYPES = ["plain", "text", "txt"]

const CALENDAR_FILE_TYPES = ["ics"]

export const FILE_TYPE_MAP = {
	image: IMAGE_FILE_TYPES,
	document: DOCUMENT_FILE_TYPES,
	table: TABLE_FILE_TYPES,
	archive: ARCHIVE_FILE_TYPES,
	audio: AUDIO_FILE_TYPES,
	video: VIDEO_FILE_TYPES,
	code: CODE_FILE_TYPES,
	email: EMAIL_FILE_TYPES,
	json: JSON_FILE_TYPES,
	text: TEXT_FILE_TYPES,
	calendar: CALENDAR_FILE_TYPES,
}

export const VALID_FILE_TYPES_ARR = Object.values(FILE_TYPE_MAP).flat()

export const VALID_FILE_TYPES = [...VALID_FILE_TYPES_ARR] as [
	string,
	...string[],
]
